import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';
import { URLSearchParams } from '@angular/http';

@Injectable()
export class DeliassortService {
  private apiUrl = '/deliassort';
  private apiSpringUrl = '/spring/deliassort';

  constructor(
    private http: HttpService) { }

  get(
    carrierCd: string,
    postCd: string,
    prefTx: string,
    townTx: string): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + "/spring" + this.apiUrl}/${carrierCd}`;
    const params: URLSearchParams = new URLSearchParams();
    params.set('postCd', postCd);
    params.set('prefTx', prefTx);
    params.set('townTx', townTx);
    return this.http.get(url, params);
  }

  upload(uploadId: number, file: File, fileSize: string, ownerId?: number): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/upload/${uploadId}`;
    const formData: FormData = new FormData();
    formData.append('uploadFile', file, fileSize);
    const header = {
      'Accept': 'application/json',
      'x-api-key': localStorage.getItem('apiKey'),
      'x-session-key': (JSON.parse(sessionStorage.getItem('loginResult')))['sessionKey'],
      'x-csrf-token': (JSON.parse(sessionStorage.getItem('loginResult')))['csrfToken']
    };
    return this.http.post(url, formData, header);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/deli-assort/deli-assort.service.ts